import React, { useEffect, useState } from "react";
import Common_Back_Header from "../../common_components/common_back_header/Common_Back_Header";
import Explore_Category_Card from "../../home/explore_by_category/explore_category_card/Explore_Category_Card";
import Common_Product_Card from "../../common_components/common_product_card/Common_Product_Card";
import Common_Heading_Holder from "../../common_components/common_heading_holder/Common_Heading_Holder";
import "./All_Products_Page.css";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getGroupByProduct } from "../../../features/products/productsSlice";
import All_Vegitables_Category_Slider from "../../product_listing/all_vegitables_category_slider/All_Vegitables_Category_Slider";
import { encodeId } from "../../../utils/common";

const All_Products_Page = () => {
  const data = Array.from({ length: 25 }, (_, index) => ({
    img: `/assets/images/products/img${(index % 5) + 1}.png`, // reuse 5 images
    label: `Product ${index + 1}`,
  }));

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const categoryId = searchParams.get("category_id");
  const categoryImage = searchParams.get("category_image");
  const [subCategoryId, setSubCategoryId] = useState(null);
  const { id } = useParams();
  const categoryWiseProduct = useSelector(
    (state) => state.product.allProductsGroup
  );

  useEffect(() => {
    dispatch(getGroupByProduct({ p_category_id: categoryId }));
  }, [dispatch, categoryId]);

  return (
    <section className="My_Orders">
      {categoryWiseProduct?.data?.map((item) => (
        <div className="container">
          <Common_Back_Header backNavigation={-1} />

          <Common_Heading_Holder headingText={item?.name} />

          <All_Vegitables_Category_Slider
            categoryImage={categoryImage}
            categoryId={id}
            setSubCategoryId={setSubCategoryId}
          />

          <div className="main_data_div">
            <div className="row">
              {item?.Products?.map((val) => (
                <div
                  className="col-xl-2 col-lg-3 col-md-3 col-sm-4 col-6 mb-3"
                  key={val?.id} // use val.id if available
                >
                  <Common_Product_Card
                    button_color={item?.button_color}
                    prodImg={val?.image}
                    prodName={val?.name}
                    background_color={item?.background_color}
                    goto={`/product-description/${encodeId(val?.id)}`} // use product id here
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default All_Products_Page;
